/*
 * dns-back-in-stock.js  (loaded on product pages only)
 * ---------------------------------------------------------------------------
 * Inline "Notify me when it's back" inside the buy box, driven by PushOwl's
 * own public API. On a sold-out variant it:
 *   - reveals the inline block and hides PushOwl's corner flyout bell,
 *   - on click calls window.pushowl.registerForEvent('back_in_stock', …) which
 *     opens PushOwl's own opt-in (the `po-hint-screen` modal, verified separate
 *     from the flyout, so hiding the flyout does not break it),
 *   - reflects an already-subscribed variant via isProductVariantSubscribed.
 * Re-syncs when Craft swaps the buy area on variant change.
 */
(function () {
  function init() {
    var wrap = document.querySelector('[data-dns-notify]');
    if (!wrap) return;

    var scope = wrap.closest('product-info') || document;
    var btn = wrap.querySelector('[data-dns-notify-btn]');
    var done = wrap.querySelector('[data-dns-notify-done]');
    var root = document.documentElement;

    function form() { return scope.querySelector('form[action*="/cart/add"]'); }
    function variantId() { var f = form(); var i = f && f.querySelector('[name="id"]'); return i ? i.value : null; }
    function addBtn() { var f = form(); return f ? f.querySelector('[name="add"]') : null; }
    function soldOut() { var b = addBtn(); return !!(b && b.hasAttribute('disabled')); }
    function poReady() { return !!(window.pushowl && typeof window.pushowl.registerForEvent === 'function'); }
    function isSubbed(id) {
      try { return !!(window.pushowl && window.pushowl.isProductVariantSubscribed && window.pushowl.isProductVariantSubscribed('back_in_stock', id)); }
      catch (e) { return false; }
    }
    function showDone() { if (btn) { btn.hidden = true; } if (done) { done.hidden = false; } }
    function showBtn() { if (btn) { btn.hidden = false; btn.disabled = false; } if (done) { done.hidden = true; } }

    function sync() {
      if (soldOut()) {
        wrap.hidden = false;
        root.classList.add('dns-hide-po-flyout');
        if (isSubbed(variantId())) { showDone(); } else { showBtn(); }
      } else {
        wrap.hidden = true;
        root.classList.remove('dns-hide-po-flyout');
      }
    }

    if (btn && !btn.dataset.bound) {
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        if (!poReady()) { return; }
        var id = variantId();
        btn.disabled = true;
        try {
          window.pushowl.registerForEvent('back_in_stock', true, id ? { productVariantId: id } : {})
            .then(function () { showDone(); })
            .catch(function () { btn.disabled = false; });
        } catch (e) { btn.disabled = false; }
        // Safety re-enable if the shopper dismisses the opt-in without subscribing.
        setTimeout(function () { if (done && done.hidden) { btn.disabled = false; } }, 6000);
      });
    }

    var t;
    function schedule() { clearTimeout(t); t = setTimeout(sync, 120); }

    sync();
    try {
      new MutationObserver(schedule).observe(scope, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['disabled']
      });
    } catch (e) {}
    // PushOwl loads asynchronously — re-check subscription state after it's up.
    setTimeout(sync, 1500);
    setTimeout(sync, 4000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
